import _ from 'lodash/fp';
import { numberWithCommas } from '@encarpkg/shared';
import { loggingData } from 'app/libs/sentry';

export const getCarName = (...args) => _.pipe(_.compact, _.join(' '))(args);

export const getCarYear = (year, formYear, returnCase) => {
	const yearStr = year?.toString().substring(2, 4) || '-';
	const monthStr = year?.toString().substring(4, 6) || '-';
	let formYearValue = '';
	let result;
	if (formYear) {
		const formYearStr = formYear?.substring(2, 4) || '-';
		formYearValue = formYearStr !== yearStr ? `(${formYearStr}년형)` : '';
	}

	switch (returnCase) {
		case 'case3':
			result = `${yearStr}/${monthStr}식 ${formYearValue}`;
			break;
		case 'case2':
			result = `${yearStr}년 ${monthStr}월 ${formYearValue}`;
			break;
		default:
			result = `${yearStr}/${monthStr}월 ${formYearValue}`;
	}
	return result;
};

export const getCarFullYear = (year, formYear) => `${getCarYear(year)}(${formYear?.toString().substring(2, 4)}년형)`;

export const getCarBodyType = ({ vehicleType, bodyName, gradeName, firstAdvertisedDateTime, checkBackDoorReplace }) => {
	let result;
	const advertisedDate = new Date(firstAdvertisedDateTime);
	const defaultDate = new Date(2017, 1, 20);

	if (vehicleType === 'CAR') {
		if (bodyName === 'SUV' || bodyName === 'RV' || bodyName === '경승합차' || bodyName === '승합차') {
			result = 'suv';
		} else {
			result = 'sedan';
		}
	} else if (vehicleType === 'TRUCK') {
		if (checkBackDoorReplace) {
			result = 'truck'; // 뒷문 교환이력: 4도어
		} else if (defaultDate <= advertisedDate) {
			result = gradeName?.indexOf('더블캡') > -1 ? 'truck' : 'truck2'; // 등급 더블캡문구: 4도어
		} else {
			result = 'truck';
		}
	}
	return result;
};

export const turstLease = (data) => data?.indexOf('LEASE') > -1;
export const turstRent = (data) => data === 'RENT_CAR';
export const turstRentSuccession = (data) => data === 'RENT_SUCCESSION';
// 엔카진단 태그 타입 null => 해당 없음, DIAGNOSIS => 엔카진단, DIAGNOSIS_P => 엔카진단+, DIAGNOSIS_PP => 엔카진단++
export const encarDiagnosisFromView = (item) => {
	if (!item.diagnosis) return null; // 엔카진단 해당 X

	const standard = item.encarDiagnosis;
	if (standard === 0) return 'DIAGNOSIS'; // 엔카진단
	if (standard === 1) return 'DIAGNOSIS_P'; // 엔카진단+
	if (standard === 2) return 'DIAGNOSIS_PP'; // 엔카진단++

	return null;
};
export const encarDiagnosisFromReadside = (item) => {
	if (!item.view) return null; // 엔카진단 해당 X

	const standard = item.view.encarDiagnosis;
	if (standard === 0) return 'DIAGNOSIS'; // 엔카진단
	if (standard === 1) return 'DIAGNOSIS_P'; // 엔카진단+
	if (standard === 2) return 'DIAGNOSIS_PP'; // 엔카진단++

	return null;
};

// modelName의 '.'을 '_.'으로 바꿔서 보냄 (Ryvuss쿼리에서 특수문자 인식 이슈)
export const modelNameConvertQuery = (modelName) => {
	if (!modelName) return modelName;
	return modelName.replace(/\./g, '_.');
};

// 리스렌트 텍스트 표시용
export const leaseTypeToText = (type) => {
	if (!type) return null;
	if (type.indexOf('LEASE') > -1) return '리스';
	if (type.indexOf('RENT') > -1) return '렌트';
	return '';
};

// 차량상세 최근본차량 금액표현
export const carItemPriceDisplay = (advType, leaseRentInfo) => {
	const isContract = advType.salesStatus === 'CONTRACT';
	let leaseRentType = null;
	if (turstLease(advType.advertisementType)) leaseRentType = 'LEASE'; // OPERATING_LEASE | FINANCING_LEASE
	if (turstRentSuccession(advType.advertisementType)) leaseRentType = 'RENT_SUCCESSION';
	if (turstRent(advType.advertisementType)) leaseRentType = 'RENT'; // 장기렌트
	// 리스렌트타입인데 데이터가 없을때 센트리전송
	if (leaseRentType && !leaseRentInfo) loggingData('There in no "LeaseRent" Data.');

	let status = isContract ? '계약중' : null;
	let per = null;
	let price = null;
	// 리스렌트 차량이 계약중일때는 '리스/렌트'가 아닌 '계약중'만 표현
	if (leaseRentType) {
		if (!isContract) {
			status = leaseTypeToText(advType.advertisementType);
		}

		// 금융리스 차량은 '차량가격' 으로 표기
		if (advType.advertisementType === 'FINANCING_LEASE') {
			price = numberWithCommas(advType.price);
		} else if (leaseRentInfo?.monthlyFee) {
			per = '월';
			price = numberWithCommas(leaseRentInfo.monthlyFee);
		} else {
			price = '-'; // 모든 조건 해당 안 될 시 방어
		}
	} else {
		price = numberWithCommas(advType.price);
	}
	return {
		status,
		per,
		price,
	};
};

export default null;
